import SampleHardwareRevision from '../sample-hardware-revision/SampleHardwareRevision';

export default class SampleFirmwareRevisionWriteDTO {

    public id: number;
    public releaseVersion: string;
    public description: string;
    public installationStatus: string;
    public fileName: string;
    public hardwareRevisions: SampleHardwareRevision[] = [];

    constructor(data: { [key: string]: any }) {
        this.id = data['id'];
        this.releaseVersion = data['releaseVersion'];
        this.description = data['description'];
        this.installationStatus = data['installationStatus'];
        this.fileName = data['fileName'];
        this.hardwareRevisions = Array.isArray(data['hardwareRevisions']) ? data['hardwareRevisions']
        .map(item => item instanceof SampleHardwareRevision ? item : new SampleHardwareRevision(item)) : [];
    }
}